import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  validateEmail(state, email) {

    console.log("kickbox email checks", email)
    // return true
    return axios.get(
      `/kickbox/validate/email?email=${email}`
    )
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
